import React from "react";
import { GenericImageUpload } from "./generic-image-upload";

interface AgentImageUploadProps {
  value?: {
    key: string;
    filename: string;
    contentType?: string;
    size?: number;
    blurhash?: string;
  } | null;
  onChange: (
    image: {
      key: string;
      filename: string;
      contentType?: string;
      size?: number;
      blurhash?: string;
    } | null
  ) => void;
  agentSlug?: string;
  imageType: "profile" | "banner";
  maxSize?: number; // in bytes
  accept?: string;
  disabled?: boolean;
  className?: string;
}

export function AgentImageUpload({
  value,
  onChange,
  agentSlug,
  imageType,
  maxSize = 5 * 1024 * 1024, // 5MB default
  accept = "image/*",
  disabled = false,
  className,
}: AgentImageUploadProps) {
  const uploadPath = agentSlug ? `agents/${agentSlug}` : undefined;

  return (
    <GenericImageUpload
      value={value}
      onChange={onChange}
      uploadPath={uploadPath}
      imageType={imageType}
      maxSize={maxSize}
      accept={accept}
      disabled={disabled}
      className={className}
    />
  );
}
